import Stack from '@/components/Custom/ModalStack';

export const unstable_settings = {
  anchor: 'index',
};

export default function PrivateTeamTeamIdEditLayoutRoute() {
  return <Stack />;
}
